import { jsxs as o, jsx as l } from "react/jsx-runtime";
const t = (e) => /* @__PURE__ */ o(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ...e,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "url(#CHIP_copilot_colored_svg__a)",
          d: "M20.352 17.756a4.72 4.72 0 0 0 1.533-3.094 60.015 60.015 0 0 0-.038-7.992 4.647 4.647 0 0 0-4.32-4.25 78.182 78.182 0 0 0-5.532-.19 78.18 78.18 0 0 0-5.533.19 4.65 4.65 0 0 0-4.31 4.24 60.02 60.02 0 0 0-.037 8 4.72 4.72 0 0 0 4.753 4.32h2.626v3.25l5.002-3.25h2.627a4.724 4.724 0 0 0 3.23-1.224Z"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "#fff",
          fillRule: "evenodd",
          d: "M10.014 7.55c-.258-1-1.679-1-1.937 0L7.8 8.629a1 1 0 0 1-.719.718l-1.079.279c-1 .258-1 1.678 0 1.936l1.08.279a1 1 0 0 1 .718.718l.278 1.08c.258 1 1.679 1 1.937 0l.278-1.08a1 1 0 0 1 .719-.718 3.962 3.962 0 0 1 1.979 0 1 1 0 0 1 .718.718l.278 1.08c.258 1 1.68 1 1.937 0l.278-1.08a1 1 0 0 1 .719-.718l1.079-.279c1-.258 1-1.678 0-1.936l-1.079-.279a1 1 0 0 1-.719-.718l-.278-1.08c-.258-1-1.678-1-1.937 0l-.278 1.08a1 1 0 0 1-.718.718 3.962 3.962 0 0 1-1.98 0 1 1 0 0 1-.718-.718l-.278-1.08Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l("defs", { children: /* @__PURE__ */ o(
        "linearGradient",
        {
          id: "CHIP_copilot_colored_svg__a",
          x1: -0.347,
          x2: 23.556,
          y1: -3.648,
          y2: 32.269,
          gradientUnits: "userSpaceOnUse",
          children: [
            /* @__PURE__ */ l("stop", { offset: 0.177, stopColor: "#8000FF" }),
            /* @__PURE__ */ l("stop", { offset: 0.88, stopColor: "#00B3FF" })
          ]
        }
      ) })
    ]
  }
);
export {
  t as default
};
